/* eslint-disable no-unused-vars, eqeqeq */
import React from "react";
import AdminHeader from "../../_components/AdminHeader/AdminHeader";
import AdminSidebar from "../../_components/AdminSidebar/AdminSidebar";
import ConfirmationAlert from "../../_components/ConfirmationAlert/ConfirmationAlert";
import authenticationService from "../../_services/authentication.service";
import userService from "../../_services/user.service";

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      isModelOpen: false,
      pkUserId: authenticationService?.currentUserValue?.id,
      password: "",
      confirmPassword: "",
      errors: {},
      isFormValid: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
  }
  handleNo = (e) => {
    this.setState({ isModelOpen: false });
  };
  handleClick = (e) => {
    this.setState({ isOpen: !this.state?.isOpen });
  };

  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;

    const re = /^[0-9\b]+$/;
    if (name === "contact") {
      if (value === "" || re.test(value)) {
        this.setState({
          [name]: value,
          errors: {
            ...errors,
            [name]: "",
          },
        });
      } else {
        this.setState({
          errors: {
            ...errors,
            [name]: "Only numbers are allowed",
          },
        });
      }
    } else {
      this.setState({
        [name]: value,
        errors: {
          ...errors,
          [name]: "",
        },
      });
    }
  }

  handlePasswordChange(e) {
    const { name, value } = e.target;
    this.setState({ confirmPassword: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.validateForm()) {
      const { pkUserId, password } = this.state;
      const model = {
        id: pkUserId,
        password: password,
        createdBy: pkUserId,
      };
      let formData = JSON.stringify(model);
      userService
        .changePassword(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  }
  responseShow(obj) {
    this.handleResetForm();

    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: obj.message,
      buttons: [
        {
          label: "Close",
          onClick: this.handleNo,
          cssclass: "btn btn-danger btn-sm ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember });
  }
  handleResetForm() {
    this.setState({
      pkUserId: authenticationService?.currentUserValue?.id,
      password: "",
      confirmPassword: "",
      errors: {},
      isFormValid: false,
    });
  }
  validateForm() {
    let { password, confirmPassword } = this.state;
    let errors = {};
    let isFormValid = true;

    if (!password) {
      isFormValid = false;
      errors["password"] = "Enter Password";
    } else {
      if (password.length < 6) {
        isFormValid = false;
        errors["password"] = "Password length is minimum 6";
      }
    }
    if (!confirmPassword) {
      isFormValid = false;
      errors["confirmPassword"] = "Enter Confirm Password";
    } else {
      if (password != confirmPassword) {
        isFormValid = false;
        errors["confirmPassword"] =
          "Password and Confirm Password should be same";
      }
    }
    this.setState({
      errors: errors,
    });
    return isFormValid;
  }
  render() {
    const showClass = `page-wrapper chiller-theme ${
      this.state?.isOpen ? "toggled" : ""
    }`;
    const { isOpen, isModelOpen, alertMember, password, confirmPassword } =
      this.state;
    return (
      <React.Fragment>
        {isModelOpen ? <ConfirmationAlert {...alertMember} /> : null}
        <div className={showClass}>
          <AdminHeader />
          <AdminSidebar handleClick={this.handleClick} />
          <main className="page-content">
            <div className="container-fluid">
              <h4 className="text-left">Change Password</h4>
              <hr className="hr" />
              <div className="row">
                <div className="col-sm-12">
                  <div className="box box-primary">
                    <form name="form" onSubmit={this.handleSubmit}>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="password">Password</label>
                              <input
                                id="password"
                                name="password"
                                value={password}
                                onChange={this.handleChange}
                                maxLength="8"
                                type="password"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.password
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Password"
                              />
                              {this.state?.errors?.password && (
                                <small class="help-block">
                                  {this.state?.errors?.password}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="confirmPassword">
                                Confirm Password
                              </label>
                              <input
                                id="confirmPassword"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={this.handlePasswordChange}
                                maxLength="8"
                                type="password"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.confirmPassword
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Confirm Password"
                              />
                              {this.state?.errors?.confirmPassword && (
                                <small class="help-block">
                                  {this.state?.errors?.confirmPassword}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 text-left">
                            <button type="submit" className="btn btn-primary">
                              SAVE
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              onClick={this.handleResetForm}
                              className="btn btn-primary"
                            >
                              RESET
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </React.Fragment>
    );
  }
}
export default ChangePassword;
